import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5cca6474")

_pushScopeId("data-v-5cca6474")
const _hoisted_1 = { class: "element-shadow" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "启用阴影：", -1)
const _hoisted_4 = {
  class: "switch-wrapper",
  style: {"flex":"3"}
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "水平阴影：", -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "垂直阴影：", -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "模糊距离：", -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "阴影颜色：", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Switch = _resolveComponent("Switch")
  const _component_Slider = _resolveComponent("Slider")
  const _component_ColorPicker = _resolveComponent("ColorPicker")
  const _component_ColorButton = _resolveComponent("ColorButton")
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_Switch, {
          checked: _ctx.hasShadow,
          onChange: _cache[1] || (_cache[1] = checked => _ctx.toggleShadow(checked))
        }, null, 8, ["checked"])
      ])
    ]),
    (_ctx.hasShadow)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_Slider, {
              min: 0,
              max: 10,
              step: 1,
              value: _ctx.shadow.h,
              onChange: _cache[2] || (_cache[2] = value => _ctx.updateShadow({ h: value })),
              style: {"flex":"3"}
            }, null, 8, ["value"])
          ]),
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_Slider, {
              min: 0,
              max: 10,
              step: 1,
              value: _ctx.shadow.v,
              onChange: _cache[3] || (_cache[3] = value => _ctx.updateShadow({ v: value })),
              style: {"flex":"3"}
            }, null, 8, ["value"])
          ]),
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_Slider, {
              min: 1,
              max: 20,
              step: 1,
              value: _ctx.shadow.blur,
              onChange: _cache[4] || (_cache[4] = value => _ctx.updateShadow({ blur: value })),
              style: {"flex":"3"}
            }, null, 8, ["value"])
          ]),
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_Popover, { trigger: "click" }, {
              content: _withId(() => [
                _createVNode(_component_ColorPicker, {
                  modelValue: _ctx.shadow.color,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = value => _ctx.updateShadow({ color: value }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withId(() => [
                _createVNode(_component_ColorButton, {
                  color: _ctx.shadow.color,
                  style: {"flex":"3"}
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
})